module.exports = __webpack_public_path__ + "images/emoji/full_moon_with_face.5cac62e18a3381c842bd.png";